import { FC, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { MainLayout } from 'views/layouts'
import { P } from 'views/components/UI/Text'
import { fetchGetAlertTextAction, updateAlertTextAction } from '../services/fetch-betesa-texts'
import { handleFetchError, BACK_PAGE } from '../constants'
import { useNotification } from 'lib/context/notification.context'
import { FormContainer, LanguageRow, LanguageRowItem, Paragraph, SelectDiv, SaveButton, TextArea } from './styled'
import Radio from '@mui/material/Radio'
import Select from 'views/components/UI/Select'
import TitleDiv from 'views/components/UI/TitleDiv'
import { EMPTY_STRING } from 'constants/global.constants'

const Home: FC = () => {
  const navigate = useNavigate()
  const { getWarning, getSuccess } = useNotification()
  const [textTypeOptions, setTextTypeOptions] = useState([])
  const [selectedTextType, setSelectedTextType] = useState('')
  const [descriptionText, setDescriptionText] = useState('')
  const [idAlertTextType, setIdAlertTextType] = useState(0)
  const [selectedLenguage, setSelectedLenguage] = useState('Español')

  useEffect(() => {
    const fetchData = () => {
      fetchGetAlertTextAction()
        .then((response) => {
          if (!response) {
            throw new Error('Data not found')
          }
          const textType = response.map((item: any) => ({
            value: item.name,
            label: item.name,
          }))
          setTextTypeOptions(textType)
        })
        .catch((error) => {
          handleFetchError(error)
        })
    }
    fetchData()
  }, [])

  useEffect(() => {
    if (selectedTextType) {
      const fetchSelectedData = () => {
        fetchGetAlertTextAction(selectedTextType)
          .then((response) => {
            if (!response || response.length === 0) {
              throw new Error('Error en la solicitud')
            }
            const [item] = response
            if (item) {
              setDescriptionText(item.description)
              setIdAlertTextType(item.id)
            } else {
              setDescriptionText('')
              setIdAlertTextType(0)
            }
          })
          .catch((error) => {
            handleFetchError(error)
          })
      }
      fetchSelectedData()
    }
  }, [selectedTextType])

  const handleLanguageChange = (language: string) => {
    setSelectedLenguage(language)
  }

  const handleUpdateAlert = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const body = {
      description: descriptionText,
    }
    if (body.description.trim() === EMPTY_STRING) {
      getWarning("Es obligatorio que el campo no este vacio ");
      return false;
    }
    updateAlertTextAction(body, idAlertTextType)
      .then(() => {
        getSuccess('Nivel de alerta actualizada correctamente')
        navigate(BACK_PAGE)
      })
      .catch((error) => {
        console.error(error)
        getWarning('Error al actualizar el inventario')
      })
  }

  const handleTextTypeChange = (selectedOption: any) => {
    if (selectedOption === 0) {
      setDescriptionText('')
      setSelectedTextType('')
    } else {
      setSelectedTextType(selectedOption)
    }
  }

  return (
    <MainLayout>
      <form onSubmit={handleUpdateAlert}>
        <TitleDiv>
          <h2 style={{ fontSize: 32 }}>Nivel de alerta</h2>
        </TitleDiv>
        <FormContainer>
          <LanguageRow>
            <LanguageRowItem>
              <Paragraph>Idioma del texto</Paragraph>
            </LanguageRowItem>
            <LanguageRowItem>
              <Radio
                checked={selectedLenguage === 'Español'}
                disabled={true}
                onChange={() => handleLanguageChange('Español')}
              />
              <Paragraph>Español</Paragraph>
            </LanguageRowItem>
            {/* <LanguageRowItem>
              <Radio
                checked={selectedLenguage === 'Inglés'}
                disabled={true}
                onChange={() => handleLanguageChange('Inglés')}
              />
              <Paragraph>Inglés</Paragraph>
            </LanguageRowItem> */}
          </LanguageRow>
          <SelectDiv>
            <Select
              style={{ width: '50%' }}
              label="Nivel de alerta"
              hideNeverChoice={true}
              options={textTypeOptions}
              value={selectedTextType || EMPTY_STRING}
              onChange={handleTextTypeChange}
            />
          </SelectDiv>
          <TextArea
            placeholder="Descripción"
            value={descriptionText}
            onChange={(e) => setDescriptionText(e.target.value)}
          />
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginTop: 30,
              alignItems: 'center',
            }}
          >
            <P
              onClick={() => {
                navigate(-1)
              }}
              style={{ color: '#2D749C', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}
            >
              Cancelar
            </P>
            <SaveButton
              type="submit"
              disabled={!selectedTextType || !descriptionText}
              descriptionText={descriptionText}
            >Guardar</SaveButton>
          </div>
        </FormContainer>
      </form>
    </MainLayout>
  )
}
export default Home
